import { render, staticRenderFns } from "./GymRouteTagAndHoldV2.vue?vue&type=template&id=1a940246&scoped=true"
import script from "./GymRouteTagAndHoldV2.vue?vue&type=script&lang=js"
export * from "./GymRouteTagAndHoldV2.vue?vue&type=script&lang=js"
import style0 from "./GymRouteTagAndHoldV2.vue?vue&type=style&index=0&id=1a940246&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a940246",
  null
  
)

export default component.exports